import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../shipments.reducer.metadata';

const namespace = 'shipmentDetails';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
